import React, { useLayoutEffect, useState } from 'react';
import { faqs } from '../data/faqs';
import type { FaqItem } from '../data/faqs';
import { REMEASURE_EVENT } from './Crosshairs';
export function Faq({
  items = faqs
}: {
  items?: FaqItem[];
}) {
  const [open, setOpen] = useState<Record<string, boolean>>({});

  /**
   * The native <details> toggle event is queued, so the browser can paint the
   * expanded answer a frame before anything downstream hears about it — the
   * registration marks then arrive late and read as a jump. Owning the open
   * state puts the disclosure and the remeasure in one commit instead.
   */
  useLayoutEffect(() => {
    document.dispatchEvent(new Event(REMEASURE_EVENT));
  }, [open]);
  const toggle = (q: string) => (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setOpen(prev => ({
      ...prev,
      [q]: !prev[q]
    }));
  };
  return <div className="faq" data-id="element-43" data-mp="no098kjfvb8m">
      {items.map(item => <details key={item.q} open={!!open[item.q]} data-id="element-44" data-mp="nn8lfvw32hsw">
          <summary onClick={toggle(item.q)} data-id="element-45" data-mp="pi7iqj7nj0nz">{item.q}</summary>
          <div className="fa" data-id="element-46" data-mp="pipjnt59e328">{item.a}</div>
        </details>)}
    </div>;
}